export default __webpack_public_path__ + "static/media/screen3.f3c5a12c.png";